import {useQuery} from "react-query";
import request from "../../../shared/request";


export const useGetAccounts = () => {

    return useQuery(['accounts'], () => request({
        url: `/api/accounts`
    }))
}